import { InjectionToken } from '@angular/core';
import { CountryConfig } from '../../models/country-config/country-config.model';

export const COUNTRY = new InjectionToken<CountryConfig>('country');
